import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

const requireAuthentication = WrappedComponent => {
  class AuthenticatedComponent extends Component {
    componentWillMount() {
      this.checkAuth(this.props);
    }

    componentWillReceiveProps(nextProps) {
      this.checkAuth(nextProps);
    }

    checkAuth(props) {
      // NOTE: isFirebaseAuthenticated is undefined (e.g. undetermined) during app initialization
      if (props.shouldRedirect) {
        const { pathname } = props.location;
        // add next query parameter, unless it's the default target after logging in (which is '/')
        const redirectAfterLogin = pathname === '/' ? undefined : pathname;
        // the following code is wrapped in a setTimeout so that when logging out there is no
        // flash of a logout page when logging out.
        // @see src/actions/index.js:logoutWithoutFirebase()
        // When logoutWithoutFirebase is called the a hard reload/redirect happens, after a sign out
        // from firebase. The Firebase authentication stream is very fast however, so this forces a
        // (soft) redirect as well causing a flash of the login page to occur before the hard
        // reload...
        setTimeout(() => {
          props.router.replace({
            pathname: '/login',
            state: { next: redirectAfterLogin },
          });
        }, 100);
      }
    }

    render() {
      if (this.props.shouldRender) {
        return <WrappedComponent {...this.props} />;
      }
      return null;
    }
  }

  // NOTE: state.firebase.authenticated can be 'undefined' which means the application
  // is still loading and the authentication state has not yet been determined.
  const mapStateToProps = state => ({
    // only render when we are guaranteed to be authenticated in both the API and Firebase
    shouldRender:
      state.user.isAuthenticated &&
      (state.featureToggles.firebaseAuthEnabled ? state.firebase.authenticated : true),
    shouldRedirect:
      !state.user.isAuthenticated ||
      (state.featureToggles.firebaseAuthEnabled ? state.firebase.authenticated === false : false),
  });

  return connect(mapStateToProps)(withRouter(AuthenticatedComponent));
};

export default requireAuthentication;



// WEBPACK FOOTER //
// ../ui-components/auth/require-authentication.jsx